var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_edit_3039125",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    width: 24.004,
    height: 24,
    viewBox: "0 0 24.004 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1520",
    "data-name": "Group 1520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    d: "M22.67,21.337H13.336L10.375,24h12.3a1.332,1.332,0,1,0,0-2.663ZM18.79,0a3.344,3.344,0,0,0-2.36.969L.867,16.545A3.315,3.315,0,0,0,0,18.639v4.027A1.337,1.337,0,0,0,1.334,24H5.374a3.251,3.251,0,0,0,2.08-.867L21.937,8.664l1.094-1.094a3.356,3.356,0,0,0,0-4.721L21.15.969A3.344,3.344,0,0,0,18.79,0ZM2.667,21.333v-2.64c.013-.08.08-.24.08-.267L15.029,6.144l3,2.64L5.614,21.213a1.315,1.315,0,0,1-.24.12Z",
    transform: "translate(0 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9949c0df.svg";
export { ForwardRef as ReactComponent };